<script>
import { fetchLogVars } from '@apis/admin/log'

export default {
  props: {
    log_seq: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      log_vars: [],
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.loading = true
      Promise.all([this.loadLogVars()])
        .catch((e) => this.$toasted.error(e.message))
        .finally(() => {
          this.loading = false
        })
    },
    async loadLogVars() {
      if (this.account_seq) return []

      const { data } = await fetchLogVars(this.log_seq)

      this.log_vars = data
    },
  },
}
</script>

<template>
  <table cellspacing="0" cellpadding="0" :class="$style.crossTable">
    <thead>
      <tr>
        <th scope="row"
          ><div>{{ $t('admin.variable') }}</div></th
        >
        <th scope="row"
          ><div>{{ $t('admin.before_value') }}</div></th
        >
        <th scope="row"
          ><div>{{ $t('admin.after_value') }}</div></th
        >
      </tr>
    </thead>
    <tbody>
      <tr v-for="data in log_vars" :key="data.var_name">
        <td>{{ data.var_name }}</td>
        <td>{{ data.before }}</td>
        <td>{{ data.after }}</td>
      </tr>
    </tbody>
  </table>
</template>

<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/admin.scss';
@import '@src/design/font.scss';
@import '@src/design/button.scss';
</style>
